import { useCallback, useEffect, useRef } from 'react';

const useSpeechMessage = ({
  setMessage,
  sendMessage,
}: {
  setMessage: (msg: string) => void;
  sendMessage: () => void;
}) => {
  const speechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = useRef(speechRecognition ? new speechRecognition() : null);

  useEffect(() => {
    if (recognition.current) {
      recognition.current.continuous = true; // Keep listening until manually stopped
      recognition.current.lang = navigator.language;
      recognition.current.maxAlternatives = 1;

      recognition.current.onstart = () => {
        console.log('Speech recognition started');
      };

      recognition.current.onresult = (e: any) => {
        const transcript = e.results[e.resultIndex][0].transcript.trim();
        setMessage(transcript); // Update the input with transcribed text
      };

      recognition.current.onend = () => {
        console.log('Speech recognition ended');
        // Do not call sendMessage() here to prevent sending the message automatically
      };

      recognition.current.onerror = (err: any) => {
        console.error('Speech recognition error:', err);
      };
    }
  }, [setMessage]);

  const startSpeech = useCallback(() => {
    recognition.current?.start();
  }, []);

  const stopSpeech = useCallback(() => {
    recognition.current?.stop();
  }, []);

  return { startSpeech, stopSpeech };
};

export default useSpeechMessage;
